import react from "react"

import {
    Box,
    Typography,
    Button
} from "@mui/material"

import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot
} from "@mui/lab"

import SupportAgentIcon from "@mui/icons-material/SupportAgent"

import { renderEvent } from "../../Agenda"
import { platformIcon } from "../../Report/NewDetailedRegister/contact_graph_exception"

import api from "../../../api"

import dayjs from "dayjs"

const LoadMore = async (url, data, setParent) => {
    setParent({ loading: true })
    const res = await api.get(`api/${url.split("api/").pop()}`)
    const newstate = { loading: false }
    if (res.status === 200) {
        const prevResults = data["results"]
        const newData = res.data
        newData["results"] = [...prevResults, ...res.data["results"]]
        newstate.events = newData
    }
    setParent(newstate)
}



const EventsComponent = ({ data, setParent }) => {

    return (
        <Box>
            <Timeline position="right" className="profile-timeline">
                {Array.isArray(data?.results) && data.results.map((item, index) => (
                    <TimelineItem key={index}>
                        <TimelineSeparator>
                            <TimelineDot className="profile-timeline-dot">
                                {renderEvent(item.event)}
                                <span className="event-mini-icon">{platformIcon(item.type)}</span>
                            </TimelineDot>
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent className="profile-timeline-content">
                            <Typography variant="body1" className="profile-timeline-content-title">
                                {item.description}
                            </Typography>
                            <Typography variant="body2">{dayjs(item.target_date).format("DD/MM/YYYY HH:mm")}
                            </Typography>
                            <Typography variant="body2" className="profile-timeline-description">
                                <Box className="profile-timeline-contact-target">
                                    <Box className="profile-timeline-target-data">
                                        <SupportAgentIcon sx={{ fontSize: "1rem" }} /> {item.target_data?.name}
                                    </Box>
                                </Box>
                                {item.long_description}
                            </Typography>
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
            {Array.isArray(data?.results) && data.next &&
                <Box className="events-show-more">
                    <Button onClick={() => LoadMore(data.next, data, setParent)}>Mostrar mais</Button>
                </Box>
            }
        </Box>
    )
}

export default EventsComponent
